<slider-principal
  [values]="arrSliderPrincipal"
  [fade]="fadeSliderPrincipal"
  [interval]="intervalSliderPrincipal"
  [ballIndicator]="ballIndicatorSliderPrincipal"
  [mousePause]="mousePauseSliderPrincipal"
></slider-principal>
<slider-produto
  (redirectTo)="router.navigate(['/produto', $event])"
  [values]="productsFeatured"
  [title]="titleSliderProdutos"
  [dots]="dotsSliderProdutos"
  [infinite]="infiniteSliderProdutos"
  [interval]="intervalSliderProdutos"
></slider-produto>
<app-news-letter *ngIf="newsletterActive"></app-news-letter>
<!-- <gcc-footer></gcc-footer> -->
